export default {
  "title": {
    "evolution": "Em risco (evolução)",
    "distribution": "Histograma do índice de fadiga",
    "indicators": "Principais indicadores de fadiga",
    "ranking": "Classificação do piloto"
  },
  "labels": {
    "driversAtRisk": "Motoristas em risco (Evolução diária)",
    "driversAtRiskKpi": "Motoristas em risco",
    "filterByRisk": "Filtrar por risco"
  },
  "selects": {
    "All": "Todos",
    "HasRisk": "Em risco"
  },
  "buttons": {
    "moreDetails": "Mais detalhes"
  },
  "graphToolTip": {
    "HasRisk": "Em risco",
    "indice": "Indice entre",
    "drivers": "motoristas"
  },
  "nfa": {
    "previousPeriod": "Período anteriror",
    "thisPeriod": "Este Período",
    "to": "a",
    "underRisk": "Baixo Risco Total",
    "driverNfa": "Representa a % de motoristas/dia com nível de fadiga acumulado em 4 períodos de tempo selecionados",
    "nfaText": "Nível de fadiga cumulativo: é um indicador que calcula a probabilidade de ocorrência de pelo menos um evento de sonolência em um dia de trabalho nas próximas 24 horas. Existem 4 níveis de fadiga acumulada, classificados de acordo com a probabilidade de sofrer um evento de sonolência:",
    "percentageOfNfaOne": "0% a 2% de chance de ter um evento de sonolência no dia seguinte",
    "percentageOfNfaTwo": "2% a 10% de chance de ter um evento de sonolência no dia seguinte",
    "percentageOfNfaThree": "10% a 20% de chance de ter um evento de sonolência no dia seguinte",
    "percentageOfNfaFour": "20% a 100% de chance de ter um evento de sonolência no dia seguinte",
    "howItGoes": "Como você está se saindo em relação ao objetivo",
    "goal": "Meta",
    "Deviations": "Desvios gerados",
    "distribution": "Desvios de distribuição",
    "deviationQuantity": "Número de desvios",
    "managmentQuantity": "Número de procedimentos para o",
    "managmentQuantityTime": "Número de procedimentos em tempo",
    "driverRanking": "Classificação do piloto",
    "rankinNunber": "Nº de classificação",
    "driverName": "Nome do motorista",
    "riskPeriod": "Risco do período",
    "evoulutionRisk": "Evolução % de fadiga do nível de risco",
    "fatigueLevel": "Nível de fadiga cumulativo",
    "titleMain": "Evolução do nível de fadiga acumulado em todas as operações"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/fatigue/detailFatigue.js